import type { RenderNode } from "../../../util/src/layout-compiler/types.js";

function getRenderNodeKey(node: RenderNode): string {
  return node.key ?? node.id;
}

export function getSiblingRenderReactKey(
  node: RenderNode,
  index: number,
  siblings: readonly RenderNode[],
): string {
  const baseKey = getRenderNodeKey(node);
  const hasDuplicate = siblings.some(
    (sibling, siblingIndex) =>
      siblingIndex !== index && getRenderNodeKey(sibling) === baseKey,
  );

  if (!hasDuplicate) {
    return baseKey;
  }

  const occurrenceIndex = siblings
    .slice(0, index + 1)
    .filter((sibling) => getRenderNodeKey(sibling) === baseKey).length;

  return `${baseKey}:duplicate:${occurrenceIndex}`;
}
